"use client";

import { useEffect, type ReactNode } from "react";
import { datadogRum } from "@datadog/browser-rum";
import {
  buildAllowedTracingUrls,
  isDatadogRumConfigured,
  SESSION_REPLAY_SAMPLE_RATE,
  SESSION_SAMPLE_RATE,
  shouldSendDatadogEvent,
} from "@/lib/observability/datadog-rum";

// Module-level flag prevents double-init under React Strict Mode and hot reloads.
let hasInitialized = false;

export function DatadogRUMProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    if (hasInitialized || !isDatadogRumConfigured()) return;
    hasInitialized = true;

    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? "",
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? "",
      site: process.env.NEXT_PUBLIC_DATADOG_SITE,
      service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
      env:
        process.env.NEXT_PUBLIC_DATADOG_ENV ||
        process.env.NEXT_PUBLIC_ENVIRONMENT ||
        "development",
      version:
        process.env.NEXT_PUBLIC_RELEASE_VERSION ||
        process.env.NEXT_PUBLIC_DATADOG_VERSION ||
        "",
      sessionSampleRate: SESSION_SAMPLE_RATE,
      sessionReplaySampleRate: SESSION_REPLAY_SAMPLE_RATE,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask",
      allowedTracingUrls: buildAllowedTracingUrls(),
      beforeSend: shouldSendDatadogEvent,
    });

    datadogRum.startSessionReplayRecording();
  }, []);

  return <>{children}</>;
}
